import React from 'react';
import { SECURITY_ACTIONS } from '../../../auth/Security';
import { SIDE_PANEL_IDS } from '../../../constants/constants';
import I18n from '../../../i18n/I18n';
import { Icons } from '../../../icons/Icons';
import type { SidePanelDeclaration, SidePanelDefinition, SidePanelPresetConfiguration } from '../../types';
import { ShareSidePanel } from './ShareSidePanel';
import type { SharePanelOptions } from './types';

const definition: SidePanelDefinition = {
    id: SIDE_PANEL_IDS.share,
    kind: 'entity',
    icon: Icons.Share,
    label: <I18n token="share" />,
    affordancePermission: { securityAction: SECURITY_ACTIONS.SHARE },
    Component: ShareSidePanel
};

export function sharePanel(
    declarationConfiguration: SidePanelPresetConfiguration<SharePanelOptions> = {}
): SidePanelDeclaration {
    const declaration: SidePanelDeclaration = {
        definition: { ...definition, ...declarationConfiguration.definition },
        hidden: declarationConfiguration.hidden,
        enabled: declarationConfiguration.enabled,
        options: declarationConfiguration.options
    };
    return declaration;
}
